<template>
	<nav class="site-nav-admin">
		<div class="site-nav-admin__overlay" ref="overlayNavigation" @click="closeDropdown"></div>
		<ul class="site-nav-admin__list-user" v-on-click-outside="closeDropdown">
            <li class="site-nav-admin__item" @click="toggle">
                <a class="site-nav-admin__link color-dark site-nav-admin__link--user" ref="user">
					<transition name="fade-in">
						<img v-if="user.photo" :src="user.photo" alt="Login image" class="site-nav-admin__img">
						<img v-else src="@/assets/images/__demo/profile/profile-placeholder.jpg" alt="Login image" class="site-nav-admin__img">
					</transition>
					<span class="link-title user-name">Welcome, {{ user.first_name }} {{ user.last_name }}</span>
					<SvgIcon
						class="ico-angle-down"
						iconName="ico-angle-down"
						:class="{'chevron-active' : agentLinksData.isOpened, 'chevron-inactive' : !agentLinksData.isOpened}"
					/>
				</a>
				<!-- Links from state -->
				<MainNavigationLinks
					:data="agentLinksData"
				/>
            </li>
		</ul>
	</nav>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import { mixin as onClickOutside } from 'vue-on-click-outside';
import MainNavigationLinks from '@/components/main/MainNavigation/MainNavigationLinks';

export default {
	components: {
		SvgIcon,
		MainNavigationLinks
	},

	data () {
		return {
			agentLinksData: {
				links: [],
				isOpened: false
			}
		};
	},
	mixins: [onClickOutside],
	computed: {
		menuItems() {
			return this.$store.getters.getMenuItems;
		},
		agentItems() {
			return this.$store.getters.getAgentItems;
		},
		adminItems() {
			return this.$store.getters.getAdminItems;
		},
		superItems() {
			return this.$store.getters.getSuperItems;
		},
		user() {
			return this.$store.getters.getUser;
		}
	},
	mounted() {
		if (this.user.role === 'admin') {
			this.agentLinksData.links = this.adminItems;
		} else if (this.user.role === 'super_admin') {
			this.agentLinksData.links = this.superItems;
		} else {
			this.agentLinksData.links = this.agentItems;
		}
	},
	methods: {
		toggle() {
			this.agentLinksData.isOpened = !this.agentLinksData.isOpened;
			if (this.agentLinksData.isOpened === true) {
				if (this.$refs.overlayNavigation) {
					this.$refs.overlayNavigation.classList.add('showOverlay');
				}
			} else {
				if (this.$refs.overlayNavigation) {
					this.$refs.overlayNavigation.classList.remove('showOverlay');
				}
			}
		},
		closeDropdown() {
			if (this.agentLinksData.isOpened === true) {
				this.agentLinksData.isOpened = false;
				if (this.$refs.overlayNavigation) {
					this.$refs.overlayNavigation.classList.remove('showOverlay');
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.site-nav-admin__overlay {
	position: fixed;
    top: 0;
    left: 0;
	bottom: 0;
	right: 0;
    width: 100%;
    height: 100vh;
    z-index: 1;
    background-color: transparent;
	transition: $dur $ease;
	display: none;

	&.showOverlay {
		display: block;
	}
}

.fade-enter-active,
.fade-leave-active {
  transition: all $dur ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
  will-change: opacity;
  transform: translateY(-30px);
}

.site-nav-admin__img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
	object-fit: cover;

	@include mq($md) {
		width: 30px;
		height: 30px;
	}
}

.site-nav-admin {
	line-height: 2;
	height: 100%;
	display: flex;
	justify-content: flex-end;
	width: 100%;

	@include mq($xl) {
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		text-align: left;
		height: auto;
	}
}

.site-nav-admin__list {
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	height: 100%;

	@include mq($xl) {
		display: block;
		width: 100%;
	}

	.site-nav-admin__item {
		&.active-link {
			background-color: $white;
		}
	}
}

.site-nav-admin__item {
	position: relative;
	display: flex;
	position: relative;
	height: 100%;
    align-items: center;
	transition: $dur $ease;
	padding-left: 55px;
	cursor: pointer;

	@include mq($xl) {
		padding-left: 25px;
	}

	@include mq($lg) {
		padding-left: 15px;
	}

	&:last-of-type {
		@include hover {
			cursor: pointer;

			.site-nav-admin__link {
				color: $dodger-blue;
			}

			.site-nav-admin__item-icon {
				color: $dodger-blue;
			}
		}
	}

	@include hover {
		cursor: pointer;

		.site-nav-admin__link {
			color: $shuttle-gray;
		}

		.site-nav-admin__item-icon {
			color: $shuttle-gray;
		}

		.ico-angle-down {
			color: $dodger-blue;
		}
	}
}

.site-nav-admin__icon {
	color: $white;
	right: 0;
	transition: $dur $ease;
	@include center(y);
}

.site-nav-admin__link {
	position: relative;
	text-decoration: none;
	font-family: $font-main;
	font-size: 14px;
	line-height: 1.5;
	transition: $dur $ease;
	font-weight: 500;
	height: 100%;
    display: flex;
    align-items: center;
	color: $dodger-blue;
	z-index: 10;

	@include hover {
		.link-title user-name {
			color: $dodger-blue;
		}

		.ico-angle-down {
			color: $dodger-blue;
		}
	}

	@include mq($md) {
		.link-title {
			display: none;
		}
	}

	&.nuxt-link-active {
		color: $red;
	}
}

.site-nav-admin__link--user {
	.link-title {
		padding-left: 6px;
	}
}

.link-title {
	display: flex;
}

.site-na__item-icon {
	svg {
		color: $black;
	}
}

.color-dark {
	color: $shuttle-gray;
}

.site-nav-admin-icon {
	display: block;
	color: $black;
	font-size: 14px;
	background-color: $red;
	width: 17px;
	height: 17px;
}

.site-nav-admin__item-icon {
	padding-right: 10px;
	color: $dodger-blue;
	transition: $dur $ease;
	font-size: 16px;

	@include mq($xl) {
		font-size: 14px;
		padding-right: 12px;
	}
}

.ico-angle-down {
    padding-right: 6px;
	color: $shuttle-gray;
	transition: $dur $ease;
	font-size: 12px;
    padding-left: 11px;
}

.site-nav-admin__list-user {
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	height: 100%;
}

//Dropdown
.site-nav-admin__dropdown {
	position: absolute;
	background-color: $white;
	padding: 18px 0;
	top: 88%;
	max-width: 209px;
	width: 100%;
	right: 0;
	box-shadow: 0 0px 7px -2px rgba(0, 0, 0, 0.75);
	z-index: 2000;

	@include mq($xl) {
		padding: 15px 0;
		top: 80px;
		width: 209px;
	}

	@include mq(1024px) {
		top: 60px;
	}

	@include mq($lg) {
		width: 170px;
		padding: 10px 0;
	}

	@include mq(640px) {
		top: 50px;
	}

	&::before {
		content: '';
		position: absolute;
		right: 22px;
		top: -10px;
		width: 24px;
		height: 24px;
		background-color: $white;
		box-shadow: 0 0px 7px -2px rgba(0, 0, 0, 0.75);
		transform: rotate(45deg);
		z-index: 0;
	}
	&::after {
		content: '';
		position: absolute;
		right: 0;
		top: 0;
		width: 55px;
		height: 24px;
		background-color: $white;
		z-index: 0;
	}
}

.site-nav-admin__dropdown-link {
	font-family: $font-main;
	font-size: 16px;
	line-height: 1.2;
	color: $shuttle-gray;
	transition: $dur $ease;
	z-index: 10;
	position: relative;
	display: flex;

	@include mq($xl) {
		font-size: 14px;
		align-items: end;
	}
}

.site-nav-admin__dropdown-icon {
	color: $fiord;
	transition: $dur $ease;
	font-size: 22px;
	padding-right: 9px;

	@include mq($lg) {
		font-size: 17px;
		height: 17px;
	}

	svg {
		height: 20px;

		@include mq($lg) {
			height: 17px;
		}
	}
}

.site-nav-admin__dropdown-item {
	display: flex;
	align-items: center;
	padding: 0 27px 19px;

	@include mq($xl) {
		padding: 10px 20px;
	}

	@include hover {
		.site-nav-admin__dropdown-link,
		.site-nav-admin__dropdown-icon {
			color: $dodger-blue;
		}
	}

	&:last-of-type {
		@include hover {
			.site-nav-admin__dropdown-link,
			.site-nav-admin__dropdown-icon {
				color: $dodger-blue;
			}
		}

		.site-nav-admin__dropdown-link {
			color: $red;
		}

		.site-nav-admin__dropdown-icon {
			color: $orange;
		}
	}

	&:nth-child(2) {
		.site-nav-admin__dropdown-icon {
			font-size: 20px;

			@include mq($lg) {
				font-size: 17px;
			}
		}
	}
}

.site-nav-admin__dropdown-item--logout {
    border-top: 1px solid $grey-light;
    padding-top: 20px;

	@include mq($xl) {
		padding-top: 10px;
		padding-bottom: 5px;
	}
}

.chevron-active {
	transform: rotateX(180deg);
	will-change: transform;
}

.user-mobile {
	display: none;
	font-weight: 500;

	@include mq($md) {
		display: block;
	}
}
</style>
